import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useResearchContext } from '@/creditflowresearch/application/Research/ResearchContext';
import { useDocumentGroupContext } from '@/creditflowresearch/application/Research/DocumentGroupContext';

const ResearchTabSelect = () => {
  const { documentGroupChanged } = useResearchContext();
  const { collection, emptyGroupIds, documentGroup } = useDocumentGroupContext();

  const options: ISelectOption[] = collection.map((tab) => ({
    label: tab.groupName,
    value: tab.groupName,
  }));
  const value = options.find((o) => o.value === (documentGroup?.groupName || 'All')) || options[0];

  const handleChange = (option: ISelectOption): void => {
    if (option) {
      documentGroupChanged(option.value as string);
    }
  };

  return (
    <Select
      value={ value }
      options={ options }
      onChange={ handleChange }
      isOptionDisabled={ (option) => {
        const tab = collection.find((t) => t.groupName === option.value);
        return tab ? emptyGroupIds.includes(tab.groupId) : false;
      } }
      isSearchable={ false }
      isSlim
      isNarrow
      size="S"
      dataTest="researchTileTabSelect"
    />
  );
};

export default ResearchTabSelect;
